import { useState, useCallback } from 'react';
import axios from 'axios';
import { setupAxios } from '../../auth';
const api = axios.create({ baseURL: process.env.REACT_APP_ACCOUNTS_API_URL || '' });
setupAxios(api);

export const useAccountCustomers = () => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadCustomers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('accounts/customers');
      const data = response.data?.data || response.data || [];
      setCustomers(Array.isArray(data) ? data : []);
      setLoaded(true);
    } catch (err: any) {
      console.error('Failed to fetch customers:', err);
      setError('Failed to load customers');
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshCustomers = useCallback(() => {
    loadCustomers();
  }, [loadCustomers]);

  return {
    customers,
    loading,
    loaded,
    error,
    loadCustomers,
    refreshCustomers,
  };
};

export const useAccountQuotes = () => {
  return [] as any[];
};

export const useAccountSalesOrders = () => {
  return [] as any[];
};

export const useAccountInvoices = () => {
  return [] as any[];
};

export const useAccountVendors = () => {
  return [] as any[];
};

export const useAccountExpenses = () => {
  return [] as any[];
};

export const useAccountPurchaseOrders = () => {
  return [] as any[];
};

export const useAccountBills = () => {
  return [] as any[];
};
